import ApiService from "src/util/api.service";

export interface VehicleStateCounter {
  state: number;
  counter: number;
}

export const getVehicleStateCounters = async (timestamp: string, signal?: AbortSignal) => {
  const { data } = await ApiService.get<VehicleStateCounter[] | { response: VehicleStateCounter[] }>(
    "/crm-core/api/v1/device/dashboard/routes-state",
    { params: { timestamp }, signal },
  );
  const counters = Array.isArray(data) ? data : data.response;
  if (!Array.isArray(counters) || counters.some((item) =>
    !item || !Number.isInteger(item.state) || !Number.isSafeInteger(item.counter) || item.counter < 0
  )) {
    throw new Error("Invalid vehicle state counter response");
  }
  return counters;
};
